<template>
    <BlockConfig title="Tabella misure"
        :valid="valid"
        @handleSave="handleSave"
        @restore="restore">
        <v-form v-model="valid">
            <div class="d-flex my-2">
                <v-text-field dense outlined
                    label="nome prova*"
                    :rules="[rules.mandatory]" 
                    v-model="config_data.title"
                ></v-text-field>
            </div>
            <div>
                <v-label>etichette<span class="caption"> - (ordine fisso)</span></v-label>
                <div class="d-flex mt-2 flex-wrap">
                    <v-text-field dense outlined label="riferimento" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.rif"></v-text-field>
                    <v-text-field dense outlined label="descrizione" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.descr"></v-text-field>
                    <v-text-field dense outlined label="risultato" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.result"></v-text-field>
                    <v-text-field dense outlined label="note" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.notes"></v-text-field>
                </div>
            </div>
            <v-divider></v-divider>
                <div class="d-flex flex-grow-1 justify-space-between font-weight-bold text-uppercase my-2">
                    <span class="d-flex">sezioni</span>
                    <v-btn div="d-flex justify-end" color="action" @click.stop="addSection"><v-icon class="pa-2" small>add_box</v-icon>sezione</v-btn>
                </div>
                <draggable
                    class="list-group draggable-area pa-2"
                    :list="config_data.newList">
                        
                    <div class="elevation-1 mt-2" v-for="(item, index) of config_data.newList" :key="index">
                        <div class="d-flex align-top grey lighten-4 pa-2">
                            <v-text-field dense outlined
                                v-model="item.title"
                                label="titolo sezione*"
                                :rules="[rules.mandatory]"
                                ></v-text-field>
                            <v-text-field dense outlined
                                v-model="item.referral"
                                class="px-2"
                                label="codice sezione*"
                                :rules="[rules.mandatory]"
                                />
                            <v-btn class="d-flex" small fab  color="action" @click.stop="deleteSection(index)"><v-icon>delete</v-icon></v-btn>
                        </div>
                        <draggable
                            class="list-group draggable-area pa-2"
                            :list="item.innerItems">
                            <div class="ml-2 d-flex flex-grow-1 align-top pa-2"
                                v-for="(item_i, index_i) of item.innerItems" :key="index_i">
                                <span class="d-flex flex-grow-1 flex-column">
                                    <span class="d-flex">
                                        <span class="text-right pl-4 pr-2">{{ (index_i+1) }}.</span>                            
                                        <v-text-field dense outlined
                                            class="px-2"
                                            v-model="item_i.element"
                                            :rules="[rules.mandatory]"
                                            hide-details
                                        ></v-text-field>
                                    </span>
                                    <span class="d-flex pr-4 ma-0 pa-0 justify-end">
                                        <v-checkbox class="ma-0" hide-details v-model="item_i.blocking" label="bloccante"></v-checkbox>
                                        <v-checkbox class="ma-0 pl-8" hide-details v-model="item_i.value_na" label="val. non applicabile"></v-checkbox>
                                    </span>    
                                </span>
                                <v-btn class="d-flex" small fab  color="action" @click.stop="deleteItem(index_i, item)"><v-icon >delete</v-icon></v-btn>
                            </div>
                        </draggable>
                        <!--div class="ml-2 d-flex flex-grow-1 align-top pa-2" v-for="(item_i, index_i) of item.innerItems" :key="index_i">
                            <span class="d-flex flex-grow-1 flex-column">
                                <span class="d-flex">
                                    <span class="text-right pl-4 pr-2">{{ (index_i+1) }}.</span>                            
                                    <v-text-field dense outlined
                                        class="px-2"
                                        v-model="item_i.element"
                                        :rules="[rules.mandatory]"
                                        hide-details
                                    ></v-text-field>
                                </span>
                                <span class="d-flex pr-4 ma-0 pa-0 justify-end">
                                    <v-checkbox class="ma-0" hide-details v-model="item_i.blocking" label="bloccante"></v-checkbox>
                                    <v-checkbox class="ma-0 pl-8" hide-details v-model="item_i.value_na" label="val. non applicabile"></v-checkbox>
                                </span>    
                            </span>
                            <v-btn class="d-flex" small fab  color="action" @click.stop="deleteItem(index_i, item)"><v-icon >delete</v-icon></v-btn>
                        </div -->
                        <div class="d-flex flex-grow-1 pa-2 justify-end">
                            <v-btn div="d-flex justify-end" color="action" @click="inner_add(item.innerItems)"><v-icon class="pa-2" small>add_box</v-icon>check</v-btn>
                        </div>
                        <v-divider class="mb-4 mt-2"></v-divider>
                    </div>
                </draggable>
        </v-form>
        <div>
            <v-label>Tutorial/Descrizione prova</v-label>
            <div class="d-flex mt-2 flex-wrap">
                <v-textarea dense outlined label="tutorial" placeholder="" v-model="config_data.tutorial_text" />
            </div>
        </div>
</BlockConfig>
</template>

<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'
import {vcheck_section_conf} from "../../../utils/itemBlockSchema"
import draggable from "vuedraggable";
// import {f_rules} from '../../../utils/commonUtils'

export default {
    components: {BlockConfig, draggable},
    mixins: [ConfigMixin],
    // props: ["data", "preview"],
    data(){
        return {
            tutorial_text: "", 
            // rules: f_rules,
            // valid: false,
            o_data: {
                title: this.data.block.label,
                newList: [vcheck_section_conf({})],
                headers: {
                    rif: "Rif.",
                    descr: "Descrizione",
                    result: "Risultato",
                    notes: "Note"
                }
            },
            pagination: {'rowsPerPage': -1},
            innerHeaders: [
                {text:"Elementi sezione", value:"referral", align:"left", sortable:false},
            ]
        }
    },
    methods: {
        addSection(){
            this.config_data.newList.push(vcheck_section_conf({}))
        },
        inner_add(curr_list){
            curr_list.push({item: ''});
        },
        deleteSection(index){
            this.config_data.newList.splice(index,1);
        },
        deleteItem(index, item){
            item.innerItems.splice(index,1);
        }
    }
}
</script>
